module.exports = "/img/ball.svg?b20294f97a93972631e01a9ccfe2760e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/ball.svg
// module id = 7q+X
// module chunks = 66